
import { createImage, fixRatio } from "../helpers/functions";
import { ref, nextTick } from "vue";
import { Cropper } from "../helpers/cropper";
import Form from "../helpers/form";
import { computed } from "vue";

declare var $;

export default {
  name: "image-uploader",
  props: {
    name: {
      type: String,
      default: () => null,
    },
    form: {
      type: Object as () => Form,
      default: () => null,
    },
    modelValue: {
      type: Object,
      default: () => null,
    },
    target: {
      type: String,
      default: () => null,
    },
    width: {
      type: String,
      default: () => "16px",
    },
    height: {
      type: String,
      default: () => "16px",
    },
    append: {
      type: Boolean,
      default: () => false,
    },
    placeholder: {
      type: String,
      default: () => "N/A",
    },
    readonly: {
      type: Boolean,
      default: () => false,
    },
    ratio: {
      type: Number,
      default: () => 1,
    },
    mimetype: {
      type: String,
      default: () => "image/jpeg",
    },
    accept: {
      type: String,
      default: () => "image/*",
    },
    uploadPermission: {
      type: String,
      default: () => "images.upload",
    },
    noCropper: {
      type: Boolean,
      default: () => false,
    },
  },
  setup(props, { emit }) {
    const processing = ref(false);
    const cropperModel = ref(null);
    const tmpImage = ref(null);
    const canvasWidth = ref(600);
    const canvasHeight = ref(600);
    const emptyHeight = computed(() => {
      let height = parseFloat(props.height.replace(/[^-\d\.]/g, ""));
      if (height > 200) {
        height = 200;
      }
      return height;
    });
    const size = computed(() => {
      let height = parseFloat(props.height.replace(/[^-\d\.]/g, ""));
      let width = parseFloat(props.width.replace(/[^-\d\.]/g, ""));
      if (height > 200) {
        return "140px";
      } else {
        let w = width / 2.5;
        if (w > 40) {
          w = 40;
        }
        return `${w}px`;
      }
    });

    const calculateImageSize = (image, limit = 800) => {
      if (image.width <= limit) {
        canvasWidth.value = image.width;
      }
      if (image.height <= limit) {
        canvasHeight.value = image.height;
      }
      if (image.width > limit || image.height >= limit) {
        const ratio = image.width / image.height;
        if (ratio >= 1) {
          canvasWidth.value = limit;
          canvasHeight.value = (canvasWidth.value * image.height) / image.width;
        } else {
          canvasHeight.value = limit;
          canvasWidth.value = (canvasHeight.value * image.width) / image.height;
        }
      }
    };
    const upload = (event) => {
      if (!props.noCropper) {
        $(cropperModel.value).modal();
      }
      const fr = new FileReader();
      fr.onload = (event) => {
        if (props.noCropper) {
          saveRequest(event.target.result, (success) => {});
        } else {
          const image: any = new Image();
          image.src = event.target.result;
          image.onload = function () {
            calculateImageSize(this);
          };
          nextTick(() => {
            setTimeout(() => {
              Cropper.start(
                tmpImage.value,
                props.ratio > 0 ? fixRatio(props.ratio) : NaN
              );
              Cropper.showImage(event.target.result);
              crop();
            }, 500);
          });
        }
      };
      fr.readAsDataURL(event.target.files[0]);
    };
    const restore = () => {
      Cropper.restore();
    };
    const crop = () => {
      Cropper.startCropping();
    };
    const save = () => {
      processing.value = true;
      const url = Cropper.getCroppedImageSrc(props.mimetype);
      const image: any = new Image();
      image.src = url;
      Cropper.showImage(url);
      image.onload = function () {
        calculateImageSize(this);
        saveRequest(url, (success) => {
          if (success) {
            $(cropperModel.value).modal("hide");
          } else {
            processing.value = false;
          }
        });
      };
    };

    const saveRequest = (url, callback) => {
      createImage(props.target, url, !props.append)
        .then((image) => {
          emit("change", image);
          if (props.form) {
            props.form.update({ [props.name]: image });
          }
          processing.value = false;
          callback(true);
        })
        .catch((error) => {
          emit("change", null);
          if (props.form) {
            props.form.update({ [props.name]: null });
          }
          callback(false);
        });
    };

    return {
      processing,
      cropperModel,
      tmpImage,
      upload,
      save,
      canvasWidth,
      canvasHeight,
      size,
      emptyHeight,
    };
  },
};
